import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Select, Store } from '@ngxs/store';
import { AssetState, ConnectPaymentMethod, ProductState, WalletPaymentData } from '@platform-frontend/checkout';
import { BusinessModel, PricingInformation, WalletPaymentMethodType } from '@platform-frontend/marketplace';
import { PLATFORM_ENVIRONMENT } from '@platform-frontend/platform';
import { InclusiveActionFilter } from '@platform-frontend/ui-tools';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { NavigationService } from '../../navigation.service';

@UntilDestroy()
@Component({
  selector: 'yat-subscription-wallet-button',
  templateUrl: './subscription-wallet-button.component.html',
  styleUrls: ['./subscription-wallet-button.component.scss']
})
export class SubscriptionWalletButtonComponent {
  constructor(private activatedRoute: ActivatedRoute, private store: Store, private navigationService: NavigationService) {}

  @Input()
  activeWallet: WalletPaymentMethodType = 'GOOGLE_PAY';

  @Select(AssetState.pricingInformation)
  pricingInformation$: Observable<PricingInformation | null>;

  @Select(AssetState.endOfPeriod)
  endOfPeriod$: Observable<Date | null>;

  @Select(ProductState.vendorName)
  vendorName$: Observable<string | null>;

  @Select(ProductState.businessModel)
  businessModel$: Observable<BusinessModel | null>;

  @Select(ProductState.isLive)
  isLive$: Observable<boolean>;

  readonly isProduction = PLATFORM_ENVIRONMENT.isProduction;
  connectActionFilter = new InclusiveActionFilter(ConnectPaymentMethod);

  onWalletPayment(paymentWalletData: WalletPaymentData): void {
    this.store
      .dispatch(new ConnectPaymentMethod(paymentWalletData))
      .pipe(
        switchMap(() => this.navigationService.gotoConfirmationOrOverview(this.activatedRoute, false)),
        untilDestroyed(this)
      )
      .subscribe();
  }
}
